import styled from 'styled-components';

interface IAreaForm {
  gridTemplateColumns?: string;
}

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;

  > h2 {
    font-weight: bold;
  }
`;
export const AreaForm = styled.div<IAreaForm>`
  display: grid;
  grid-template-columns: ${props => props.gridTemplateColumns || '1fr 1fr 1fr'};
  gap: 1rem;

  @media (max-width: 426px) {
    grid-template-columns: 1fr;

    button {
      width: 100%;
      max-width: 100%;
      padding: .4rem 0 !important;
      margin: 0;
    }
  }
`;

export const AreaButton = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: end;
  gap: 15px;
  margin-top: 1rem;
  
  @media (max-width: 768px) {
    flex-direction: column;
    > button {
      width: 100%;
      max-width: 100%;
      padding: 0.4rem 0 !important;
      margin: 0;
    }
  }
`;